import { DiagnosticRating } from '@malou-io/package-utils';

import { AVERAGE_KEYWORD_POSITION, BAD_KEYWORD_POSITION, GOOD_KEYWORD_POSITION } from ':shared/constants';

export const getKeywordRatingFromPosition = (googlePosition: number): DiagnosticRating => {
    if (BAD_KEYWORD_POSITION.includes(googlePosition)) {
        return DiagnosticRating.BAD;
    }
    if (AVERAGE_KEYWORD_POSITION.includes(googlePosition)) {
        return DiagnosticRating.AVERAGE;
    }
    if (GOOD_KEYWORD_POSITION.includes(googlePosition)) {
        return DiagnosticRating.GOOD;
    }
    return DiagnosticRating.VERY_BAD;
};
